// extracted by mini-css-extract-plugin
export default {"notice":"CookieNotice_notice__qHxQt","text":"CookieNotice_text__LkbYO","link":"CookieNotice_link__XTMjm","button":"CookieNotice_button__z8g0B"};